import React from "react";

const PageHeader = () => {
  return (
    <div className="page-header">
      <div className="container">
        <div className="tech-header">
          <h2>
            At BelSoft Systems, we innovate with technology for tailored
            solutions.
          </h2>
          <p>
            We specialize in using JavaScript and React to create dynamic
            frontend solutions, alongside HTML for creating sturdy interfaces.
            Our dedication to innovation ensures customized solutions that
            surpass expectations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
